import Vue from 'vue'
import VueResource from 'vue-resource'

import config from '../config'

Vue.use(VueResource)

export function createResource (Vue, url, ...args) {
  return Vue.$resource(config.serverURI + url, ...args)
}

export function updateAuthHeader (Vue, token) {
  Vue.http.headers.common['Authorization'] = 'Bearer ' + token
}

export default {
  createResource,
  updateAuthHeader
}



// WEBPACK FOOTER //
// ./src/api/helper.js